export const TARGET_TYPES = [
  'political',
  'country',
  'administrative_area_level_1',
  'administrative_area_level_2',
  'colloquial_area',
  'locality',
  'natural_feature',
]

/**
 * Handle all status that are related to errors
 * @param {*} GoogleMaps - The api object
 * @param {*} exception - A PlacesService exception
 */
export function handleNotOk(GoogleMaps, exception) {
  const { INVALID_REQUEST, OVER_QUERY_LIMIT, REQUEST_DENIED, UNKNOWN_ERROR } =
    GoogleMaps.PlacesServiceStatus

  if ([INVALID_REQUEST, OVER_QUERY_LIMIT, REQUEST_DENIED, UNKNOWN_ERROR].includes(exception.code)) {
    throw new Error(`Request failed! Error status: ${exception.code}`)
  }
}
